/**
 * Definições compartilhadas do módulo Formação de Preço (CBS/IBS).
 *
 * Os inputs de custo/percentuais por segmento são editados na aba
 * Parâmetros (FormacaoPrecoParamsSection) e lidos, somente leitura, na aba
 * Formação de Preço (dashboard) — tanto no modo simplificado (3 segmentos
 * hardcoded abaixo) quanto no modo avançado (segmentos do Cadastro Mestre).
 */

export const SEGMENT_DEFS = [
  {
    id: "pecas",
    titulo: "Demais produtos",
    subtitulo: "ICMS não-cumulativo → CBS/IBS com crédito amplo",
    critico: false,
    defaults: { custo: 1000, pctFrete: 2, pctComissao: 3, pctOpex: 5, pctMargem: 10 },
    notaAtual: "ATUAL: ICMS 18% + PIS 1,65% + COFINS 7,6% = 27,25% bruto; crédito integral no custo de aquisição.",
    notaFuturo: "FUTURO: CBS+IBS pleno; crédito integral no custo de aquisição — mesma lógica do ICMS atual.",
  },
  {
    id: "oficina",
    titulo: "Serviços",
    subtitulo: "ISS → carga efetiva sobe (mão de obra não credita)",
    critico: true,
    defaults: { custo: 1000, pctFrete: 0, pctMateriais: 35, pctComissao: 3, pctOpex: 5, pctMargem: 10 },
    notaAtual: "ATUAL: ISS sobre o PV, sem crédito. PV = CT÷(1−ISS−Comm−OpEx−ML).",
    notaFuturo: "FUTURO: CBS+IBS pleno; crédito apenas sobre materiais — mão de obra não é insumo creditável.",
  },
  {
    id: "veiculos",
    titulo: "Produtos com ST ou monofásicos",
    subtitulo: "ICMS-ST atual → CBS/IBS sobre margem",
    critico: false,
    defaults: { custo: 100000, pctFrete: 0.5, pctComissao: 2, pctOpex: 3, pctMargem: 3 },
    notaAtual: "ATUAL: ICMS-ST — a empresa não recolhe ICMS na saída (retido pelo substituto na cadeia). Carga efetiva ≈ 0%.",
    notaFuturo: "FUTURO: CBS+IBS pleno; crédito integral no custo de aquisição (a NF do fornecedor terá CBS/IBS destacado).",
  },
];

export const DEFAULTS_BY_TIPO = {
  servico: { custo: 1000, pctFrete: 0, pctMateriais: 35, pctComissao: 3, pctOpex: 5 },
  normal: { custo: 1000, pctFrete: 2, pctComissao: 3, pctOpex: 5 },
  "ST-monofasico": { custo: 1000, pctFrete: 2, pctComissao: 3, pctOpex: 5 },
  "base-reduzida": { custo: 100000, pctFrete: 0.5, pctComissao: 2, pctOpex: 3 },
};

/**
 * Campos editáveis por segmento (mesma ordem exibida nos cards).
 * `servicoOnly`: só aparece para segmentos de serviço/oficina.
 */
export const FORMACO_INPUT_FIELDS = [
  { field: "custo", label: "Custo de aquisição / serviço (R$)", unit: "R$" },
  { field: "pctFrete", label: "% Frete / acondicionamento", unit: "%" },
  { field: "pctMateriais", label: "% Materiais no custo total (creditável)", unit: "%", servicoOnly: true },
  { field: "pctComissao", label: "% Comissão de vendas", unit: "%" },
  { field: "pctOpex", label: "% Despesas operacionais", unit: "%" },
  { field: "pctMargem", label: "% Margem líquida desejada", unit: "%" },
];
